module.exports = __webpack_public_path__ + "static/img/18.8d58a3c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/1/eng/18.png
// module id = upzY
// module chunks = 0